import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14z"
}), 'FilterSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterSharp.js
// module id = 3662
// module chunks = 2